import React from "react";
import CloseIcon from "@mui/icons-material/Close";

interface ModalHeaderProps {
  onClose: () => void;
  theme?: "light" | "dark";
}

const ModalHeader: React.FC<ModalHeaderProps> = ({ onClose, theme = "light" }) => {
  return (
    <div className={`px-3 sm:px-6 py-3 sm:py-4 border-b flex items-center justify-between ${
      theme === "dark" 
        ? "border-slate-700 bg-gradient-to-r from-indigo-600 to-indigo-700" 
        : "border-slate-100 bg-gradient-to-r from-primary to-primaryLight"
    }`}>
      <h2 className="text-lg sm:text-xl font-bold text-white">Patient Summary</h2>
      <button
        onClick={onClose}
        className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-white/20 hover:bg-white/30 flex items-center justify-center text-white transition-colors"
      >
        <CloseIcon sx={{ fontSize: 18 }} className="sm:text-[20px]" />
      </button>
    </div>
  );
};

export default ModalHeader;

